import axios from "axios";

const API_URL = "https://www.staveotech.com/blogs/wp-json/wp/v2";

export const API_Post_URL =
  "https://www.staveotech.com/blogs/wp-json/wp/v2/posts";

export async function fetchAllPosts() {
  try {
    const res = await fetch(
      "https://www.staveotech.com/blogs/wp-json/wp/v2/posts?_embed",
      { mode: "cors", cache: "no-store" },
    );

    const data = await res.json();

    return data.map((post) => ({
      ...post,
      featuredImage:
        post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
        "/images/default.jpg",
      authorName: post._embedded?.author?.[0]?.name || "Unknown",
      dateFormatted: new Date(post.date).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
      timeFormatted: new Date(post.date).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      }),
      tags:
        post._embedded?.["wp:term"]
          ?.flat()
          ?.filter((term) => term.taxonomy === "post_tag")
          ?.map((tag) => ({
            id: tag.id,
            name: tag.name,
            slug: tag.slug,
          })) || [],
    }));
  } catch (err) {
    console.error("Failed to fetch posts:", err);
    return [];
  }
}

export async function fetchPostBySlug(slug) {
  try {
    const res = await fetch(
      `https://www.staveotech.com/blogs/wp-json/wp/v2/posts?slug=${slug}&_embed`,
      { mode: "cors", cache: "no-store" },
    );
    const data = await res.json();
    const post = data[0];

    if (!post) return null;

    const tags =
      post._embedded?.["wp:term"]
        ?.flat()
        ?.filter((term) => term.taxonomy === "post_tag")
        ?.map((tag) => `#${tag.name.replace(/\s+/g, "")}`)
        ?.join(" ") || "";

    return {
      ...post,
      tags,
    };
  } catch (err) {
    console.error("Failed to fetch post by slug:", err);
    return null;
  }
}
